import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { CardType, useCardData } from '~/composables/useCardData';
import { useCardPrice } from '~/composables/useCardPrice';
import CardLink from '~/components/card/CardLink.vue';
import CardPriceTag from '~/components/card/CardPriceTag.vue';
import CardActions from '~/components/card/CardActions.vue';
import CardImage from '~/components/card/CardImage.vue';
import CardContent from '~/components/card/CardContent.vue';
import CardNewLabel from '~/components/card/CardNewLabel.vue';
import CardTitle from '~/components/card/CardTitle.vue';
import CardExcerpt from '~/components/card/CardExcerpt.vue';
import CardFooter from '~/components/card/CardFooter.vue';
import { AlgoliaResource, Resource } from '~/types/resource';

type LineClampValue = 1 | 2 | 3 | 4 | 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    type: null,
    item: null,
    showAuthor: { type: Boolean },
    minimal: { type: Boolean },
    clampTitle: null,
    queryId: null,
    showExcerpt: { type: Boolean },
    algoliaSendEvent: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  type: CardType;
  item: Resource | AlgoliaResource;
  showAuthor?: boolean;
  minimal?: boolean;
  clampTitle?: LineClampValue;
  queryId?: string;
  showExcerpt?: boolean;
  algoliaSendEvent?: () => void;
};

const { $mzAnalyticsApi } = useContext();



const cardData = useCardData(props.item, props.type);
const { showPriceTag } = useCardPrice(cardData);


const handleClick = () => {
  emit('click');
  const pageType = (props.item as Resource).type;
  let analyticsName = '';
  let productAreas = '';
  if (pageType === 'teaching-resource') {
    analyticsName = 'resource';
    productAreas = 'resources';
  } else if (pageType === 'resource-pack') {
    analyticsName = 'pack';
    productAreas = 'resources';
  } else if (pageType === 'blog') {
    analyticsName = 'blog_card';
    productAreas = 'content';
  } else if (pageType === 'podcast') {
    analyticsName = 'podcast_card';
    productAreas = 'content';
  } else {
    analyticsName = pageType.replace('-', '_');
    productAreas = 'resources';
  }
  $mzAnalyticsApi({
    event: 'click',
    name: analyticsName + '_card.selected',
    productArea: productAreas,
    entityType: (props.item as Resource).type,
    entityId: props.item.id,
  });
};

return { __sfc: true,$mzAnalyticsApi, props, cardData, showPriceTag, emit, handleClick, CardLink, CardPriceTag, CardActions, CardImage, CardContent, CardNewLabel, CardTitle, CardExcerpt, CardFooter }
}

})